import React, { useState, useEffect, useCallback } from 'react';
import { Tabs } from 'antd';
import { useSearchParams } from 'react-router-dom';
import { useAuth } from '../utils/auth';
import aiContentService from '../services/aiContentService';
import AiContentGenerate from './AiContentGenerate';
import AiContentConfig from './AiContentConfig';
import AiContentHistory from './AiContentHistory';
import Products from './Products';
import Campaigns from './Campaigns';

const AiContent = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = searchParams.get('tab') || 'generate';
  const { tenant } = useAuth();
  const tenantId = tenant?.id;

  const [styleReference, setStyleReference] = useState('');
  const [defaultProvider, setDefaultProvider] = useState(null);
  const [cities, setCities] = useState([]);

  const fetchTenantSettings = useCallback(async () => {
    if (!tenantId) return;
    try {
      const response = await aiContentService.getTenantSettings(tenantId);
      if (response.success && response.data) {
        setStyleReference(response.data.styleReference || '');
        setDefaultProvider(response.data.defaultProvider || null);
        try {
          setCities(response.data.cities ? JSON.parse(response.data.cities) : []);
        } catch (e) {
          setCities([]);
        }
      }
    } catch (error) {
      console.error('获取租户配置失败:', error);
    }
  }, [tenantId]);

  useEffect(() => {
    fetchTenantSettings();
  }, [fetchTenantSettings]);

  const handleTabChange = (key) => {
    setSearchParams({ tab: key });
    // 切回 generate tab 时重新加载设置
    if (key === 'generate') {
      fetchTenantSettings();
    }
  };

  const handleSettingsChange = (updates) => {
    if (updates.styleReference !== undefined) setStyleReference(updates.styleReference || '');
    if (updates.defaultProvider !== undefined) setDefaultProvider(updates.defaultProvider || null);
    if (updates.cities !== undefined) setCities(updates.cities || []);
  };

  const tabItems = [
    {
      key: 'generate',
      label: 'AI生成',
      children: <AiContentGenerate styleReference={styleReference} defaultProvider={defaultProvider} cities={cities} />,
    },
    {
      key: 'products',
      label: '商品管理',
      children: <Products />,
    },
    {
      key: 'campaigns',
      label: '活动管理',
      children: <Campaigns />,
    },
    {
      key: 'history',
      label: '生成历史',
      children: <AiContentHistory />,
    },
    {
      key: 'config',
      label: '配置',
      children: <AiContentConfig onSettingsChange={handleSettingsChange} />,
    },
  ];

  return (
    <Tabs
      activeKey={activeTab}
      onChange={handleTabChange}
      items={tabItems}
      size="large"
      style={{ marginTop: -8 }}
    />
  );
};

export default AiContent;
